<div class="loader-container" *ngIf="!view || !view?.data">
    <i  class="fas fa-spinner fa-spin"></i>
</div>
<div *ngIf="view && view?.data">
    <div style="margin:10px">
        <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
    </div>
</div>
